<template>
    <div id="dispatch-modal">
        <div class="row">
            <div class="col">
                <div class="row">
                    <div class="col-md-12">
                        <table class="table table-sm table-bordered">
                            <thead class="thead-light">
                                <tr v-if="finisehdProductCode">
                                    <th style="width: 40%;" class="thead-light">Producto Terminado</th>
                                    <td>{{ finisehdProductCode }}</td>
                                </tr>
                                <tr>
                                    <th style="width: 40%;" class="thead-light">Mezcla Comercial</th>
                                    <td>{{ commercialMixCode }}</td>
                                </tr>
                                <tr>
                                    <th class="thead-light">Cosecha</th>
                                    <td>{{ harvest }}</td>
                                </tr>
                            </thead>
                        </table>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col-md-12">
                        <label>Semielaborado:</label>
                    </div>
                    <div class="col-md-12">
                        <div class="d-flex align-items-center">
                            <div style="flex: 1;">
                                <v-select :options="othersSemiElaborateList" v-model="otherSemiElaborate"
                                        @input="showStock(otherSemiElaborate.code, harvest)">
                                    <span slot="no-options">No se encontraron otros Semielaborados</span>
                                </v-select>
                            </div>
                        </div>
                        <div class="row" v-if="stockOtherGb.text">
                            <div class="col-md-12">
                                <table style="margin-bottom: 0px !important" class="table table-sm table-bordered" 
                                    :class="stockOtherGb.stock > 0? 'table-supply-stock-success' : 'table-supply-stock-danger'">
                                    <tr>
                                        <th class="text-left pl-2" style="width: 15% !important;">
                                            <i class="fas fa-cubes"></i>
                                            Stock:
                                        </th>
                                        <th style="width: 15% !important;" class="text-right pr-2">
                                            <span>{{ stockOtherGb.text }}</span>
                                        </th>
                                        <th class="text-left pl-2" style="width: 18% !important;">
                                            <i class="fas fa-seedling"></i>
                                            Cosecha:
                                        </th>
                                        <th style="width: 8% !important;" class="text-right pr-2">
                                            <span>{{ stockOtherGb.harvest }}</span>
                                        </th>                                                        
                                        <th :class="stockOtherGb.stock > 0? 'border-left-success' : 'border-left-danger'" 
                                            class="text-left pl-2" style="width: 20% !important;">
                                            <i class="fas fa-clock mr-2"></i>
                                            Actualizado:
                                        </th>
                                        <th class="text-right pr-2" style="width: 15% !important;">
                                            <span>{{ stockOtherGb.updatedStockAtString }}</span>
                                        </th>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 mt-4">
                        <button class="btn btn-success btn-block" @click="save">
                            <i class="fas fa-save"></i>
                            Guardar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Put, Get } from "@/helper/axios";
export default {
    name: "otherSemiElaborateModal",
    props: [
        "sampleId",
        "detailId",
        "commercialMixCode",
        "othersSemiElaborateList",
        "finisehdProductCode",
        "harvest"
    ],
    data() {
        return {
            apiUrl: this.$store.getters.apiUrl,
            Put,
            Get,
            otherSemiElaborate: {},
            stockOtherGb: {}
        };
    },
    watch: {
        detailId() {
            this.otherSemiElaborate = {}
        },
    },
    methods: {
        save() {
            this.$store.commit("setLoading", true);
            let data = {
                otherSemiElaborateCode: this.otherSemiElaborate.code,
                detailId: this.detailId
            }
            this.Put(`${this.apiUrl}v1/requestsample/${this.sampleId}/details/saveOtherSemielaborate`, data, () => {
                    this.$store.commit("setLoading", false);
                    this.otherSemiElaborate = {}
                    window.toastr.success('Otro Semielaborado Actualizado Correctamente.');
                    this.$emit("saveOtherSemilaborate");
                }
            );
        },
        showStock(sku, harvest) {
            this.stock = {}
            this.$store.commit("setLoading", true);
            let data = 'Sku=' + sku + '&Type=GB'
            if (harvest)
                data += '&Harvest=' + harvest
            this.Get(this.apiUrl + "v1/MasterItems/GetStock?" + data, (res) => {
                this.stockOtherGb = res.data                  
            });
            this.$store.commit("setLoading", false);
        },
    },
};
</script>

<style scoped></style>
